import React, { useEffect } from "react";
import { Box } from "@mui/material";
import styled, { keyframes } from "styled-components";
import PhotoSlider from "./PhotoSlider";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  animation: ${fadeIn} 1s ease forwards;
`;

const StyledLine = styled.div`
  position: relative;
  width: 30%;
  height: 2px;
  background-color: #f36e20; /* Add your desired color here */
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: #f36e20;
  margin: 1rem 0;
  animation: ${slideIn} 1s ease forwards;
`;

const Paragraph = styled.p`
  font-size: 1.2rem;
  color: #666;
  max-width: 800px;
  margin: 0 auto 2rem;
  padding: 0 20px;
  text-align: justify;
  animation: ${fadeIn} 1s ease forwards;
`;

function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);
  return (
    <div style={{ marginTop: "70px" }}>
      <TitleWrapper>
        <StyledLine />
        <Title>About Us</Title>
        <StyledLine />
      </TitleWrapper>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          borderRadius: "16px",
          marginBottom: "2rem",
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.1)",
          padding: "20px",
        }}
      >
        <Paragraph>
          Rebuild industries LLC is a small family business that would love to
          help you create your family dream house. From one family to another we
          know how important it is to want the best environment for our love
          ones to grow together and share memories in. We would like to thank
          you in advance for trusting and allowing us in being part of helping
          you create that dream become a reality. From demolishing to
          remodeling, electricity, and pulmonary, the options are limitless. You
          want it we can do it. Remember the only limit is what you set in your
          mind to. For our motto is "Anything is possible as long as you put
          your mind set to it"
        </Paragraph>
      </Box>
      <PhotoSlider />
    </div>
  );
}

export default About;
